import { render, staticRenderFns } from "./jxfwDetail.vue?vue&type=template&id=5a2eaff6&scoped=true"
import script from "./jxfwDetail.vue?vue&type=script&lang=js"
export * from "./jxfwDetail.vue?vue&type=script&lang=js"
import style0 from "./jxfwDetail.vue?vue&type=style&index=0&id=5a2eaff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2eaff6",
  null
  
)

export default component.exports